import { useTranslation } from "react-i18next";
import { Button, Toast } from "@/shared/ui";

interface Props {
  isEditMode?: boolean;
  onSaveDraft?: () => void;
  isSavingDraft?: boolean;
  draftSaveStatus?: "idle" | "saving" | "saved" | "error";
  onDraftStatusReset?: () => void;
  disabled?: boolean;
}

export default function FillContractHeader({
  isEditMode,
  onSaveDraft,
  isSavingDraft,
  draftSaveStatus,
  onDraftStatusReset,
  disabled,
}: Props) {
  const { t } = useTranslation("FillContractPage");

  return (
    <>
      <div className="flex items-center justify-between pb-4 border-b surface-base-stroke mb-5 pt-1">
        <h1 className="text-display-xs content-base-primary">
          {isEditMode ? t("title_edit") : t("title")}
        </h1>
        {onSaveDraft && (
          <Button type="button" variant="secondary" onClick={onSaveDraft} disabled={isSavingDraft || disabled}>
            {isSavingDraft
              ? t("draft.saving")
              : isEditMode
                ? t("draft.save")
                : t("draft.saveDraft")}
          </Button>
        )}
      </div>
      {(draftSaveStatus === "saved" || draftSaveStatus === "error") && (
        <div className="fixed bottom-6 right-6 z-50">
          <Toast
            key={draftSaveStatus}
            color={draftSaveStatus === "saved" ? "positive" : "negative"}
            text={draftSaveStatus === "saved" ? (isEditMode ? t("messages.contractSaved") : t("draft.saved")) : t("draft.saveFailed")}
            autoCloseDuration={5000}
            onClose={onDraftStatusReset}
          />
        </div>
      )}
    </>
  );
}
